module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.visibleItems), function(item, index) {
    return _c('div', {
      staticClass: "col-sm-6 col-lg-4 col-xl-3 card-container"
    }, [_c('erco-object-card', {
      attrs: {
        "title": item.S_de_Objekt,
        "type": item.S_Zusatz,
        "imageSrc": item.S_Stellvertreterbild,
        "date": item.TS_Aenderungsdatum,
        "publishdate": item.TS_online_Liveserver,
        "offlinedate": item.TS_offline_Liveserver,
        "objectId": item.PKM_Objekt,
        "status": item.S_Status,
        "onlineUrl": item.onlineUrl,
        "previewUrl": item.previewUrl,
        "isProductive": item.isProductive,
        "checked": _vm.belongsToSelection(item.PKM_Objekt),
        "category": item.S_Bereich,
        "specification": item.S_Spezifikation,
        "genus": item.S_Gattung
      }
    })], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6624e3dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/ErcoObjectCardOverview.vue
// module id = 628
// module chunks = 0